<div class="summary-table-container">
  <div class="table-main-section">
    <!-- Left section -->
    <div class="left-main-column">
      <div class="left-top"></div>
      <div class="left-middle">{{ HEADERS.stops }}</div>
      <div class="left-bottom">{{ HEADERS.volume }}</div>
    </div>

    <!-- Right section -->
    <div class="right-main-column">
      <!-- Delivery Section -->
      <div class="header-section-container">
        <div class="main-header top-right-table-column-header">
          {{ HEADERS.delivery }}
        </div>

        <div class="header-section">
          <div class="data-section">
            <div class="sub-header">{{ HEADERS.total }}</div>
            <div class="table-text">{{ totalDeliveryStops }}</div>
            <div class="table-text">{{ totalDeliveryVolume }}</div>
          </div>

          <div class="data-section">
            <div class="sub-header">{{ HEADERS.completed }}</div>
            <div class="table-text">{{ completedDeliveryStops }}</div>
            <div class="table-text">{{ completedDeliveryVolume }}</div>
          </div>

          <div class="data-section">
            <div class="sub-header">{{ HEADERS.pending }}</div>
            <div class="table-text">{{ pendingDeliveryStops }}</div>
            <div class="table-text">{{ pendingDeliveryVolume }}</div>
          </div>
        </div>
      </div>
      <!-- Pickups Section -->
      <div class="header-section-container">
        <div class="main-header top-right-table-column-header">
          {{ HEADERS.pickups }}
        </div>
        <div class="header-section">
          <div class="data-section">
            <div class="sub-header">{{ HEADERS.total }}</div>
            <div class="table-text">{{ totalPickupStops }}</div>
            <div class="table-text">{{ totalPickupVolume }}</div>
          </div>

          <div class="data-section">
            <div class="sub-header">{{ HEADERS.completed }}</div>
            <div class="table-text">{{ completedPickupStops }}</div>
            <div class="table-text">{{ completedPickupVolume }}</div>
          </div>

          <div class="data-section">
            <div class="sub-header">{{ HEADERS.pending }}</div>
            <div class="table-text">{{ pendingPickupStops }}</div>
            <div class="table-text">{{ pendingPickupVolume }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
